import { useState } from "react";
import { Page, useCurrent } from "./common";
import { PageHead, StatusBadge, Modal } from "../components/ui";
import { Icon } from "../components/Icons";
import { actions } from "../lib/store";
import { useCan } from "../lib/auth";
import { fmtDate } from "../lib/format";

export default function Reports() {
  const p = useCurrent();
  const canEdit = useCan("reports");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", period: "July 2026", summary: "", highlights: "" });
  if (!p) return null;

  function create() {
    if (!form.title.trim()) return;
    actions.prepareReport(p!.id, form.title, form.period, form.summary, form.highlights.split("\n"));
    setForm({ title: "", period: "July 2026", summary: "", highlights: "" });
    setOpen(false);
  }

  return (
    <Page max={920}>
      <PageHead kicker={`${p.name} · Communications`} title="Reports">
        {canEdit && <button className="btn accent sm" onClick={() => setOpen(true)}><Icon.plus width={15} />Prepare report</button>}
      </PageHead>

      <div className="col reveal" style={{ gap: 16 }}>
        {p.reports.map((r) => (
          <div key={r.id} className="card pad hoverable">
            <div className="row between wrap" style={{ gap: 12 }}>
              <div className="row" style={{ gap: 14 }}>
                <div style={{ width: 46, height: 46, borderRadius: 12, background: "var(--paper-2)", color: "var(--accent-ink)", display: "grid", placeItems: "center", flexShrink: 0 }}><Icon.report width={22} /></div>
                <div>
                  <div className="row" style={{ gap: 10 }}><h3 className="serif" style={{ fontSize: 21 }}>{r.title}</h3><StatusBadge status={r.status} /></div>
                  <div className="dim" style={{ fontSize: 12.5, marginTop: 3 }}>{r.period}{r.issuedOn ? ` · Issued ${fmtDate(r.issuedOn)}` : " · Not yet issued"}</div>
                </div>
              </div>
              <div className="row" style={{ gap: 8 }}>
                {canEdit && r.status === "draft" && <button className="btn accent sm" onClick={() => actions.issueReport(p.id, r.id)}><Icon.send width={14} />Issue</button>}
                <button className="btn ghost sm"><Icon.download width={14} />PDF</button>
              </div>
            </div>
            <p className="muted" style={{ marginTop: 14, fontSize: 15, lineHeight: 1.6 }}>{r.summary}</p>
            {r.highlights.length > 0 && (
              <div className="col" style={{ gap: 8, marginTop: 14 }}>
                {r.highlights.map((h, i) => <div key={i} className="row" style={{ gap: 10 }}><Icon.check width={16} style={{ color: "var(--ok)", flexShrink: 0 }} /><span style={{ fontSize: 14 }}>{h}</span></div>)}
              </div>
            )}
          </div>
        ))}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title="Prepare a report">
        <div className="col" style={{ gap: 14 }}>
          <div className="field"><label>Title</label><input className="input" placeholder="Progress Report — July" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
          <div className="field"><label>Period</label><input className="input" value={form.period} onChange={(e) => setForm({ ...form, period: e.target.value })} /></div>
          <div className="field"><label>Summary</label><textarea className="textarea" placeholder="Where the project stands this period…" value={form.summary} onChange={(e) => setForm({ ...form, summary: e.target.value })} /></div>
          <div className="field"><label>Highlights <span className="dim">(one per line)</span></label><textarea className="textarea" placeholder={"Living room approved\nKitchen revision issued"} value={form.highlights} onChange={(e) => setForm({ ...form, highlights: e.target.value })} /></div>
          <div className="row" style={{ justifyContent: "flex-end", gap: 10 }}><button className="btn ghost" onClick={() => setOpen(false)}>Cancel</button><button className="btn accent" onClick={create}>Create draft</button></div>
        </div>
      </Modal>
    </Page>
  );
}
